<template>
    <el-dialog
        :visible.sync="detail.dialog"
        width="30%"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        class="book-dialog-header">
        <el-row class="book-pad-btm">
            <el-col :span="24">
                <span class="head-font">
                    Confirm
                </span>
            </el-col>
        </el-row>
        <div class="custom-infor-pad">
            <div style="border: 0.5px solid #e0e0e0;"></div>
        </div>
        <div>
            <el-row class="book-pad-btm booking-pad-20">
                <span>กรุณากรอกรหัสผ่านเพื่อยืนยัน</span>
            </el-row>
            <el-row class="booking-pad-20 booking-select-display">
                <span>จำนวนรายการที่เลือก:&nbsp;{{getShipflowRowSelected}}</span>
            </el-row>
            <el-row>
                <el-input
                    v-model="confirmPassword"
                    class="book-pad-btm booking-pad-20"
                    type="password"
                    placeholder="Password"
                    >
                </el-input>
            </el-row>
            <el-row class="book-pad-btm booking-pad-20">
                <el-button @click="detail.dialog = false">ยกเลิก</el-button>
                <el-button type="primary" @click="submitForm">ตกลง</el-button>
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import { eventBus } from '@/main'
export default {
    name: 'BookingDialogConfirm',
    props: {
        detail: {
            type: Object,
            default: () => {
                return {
                    dialog: false
                }
            }
        }
    },
    data () {
        return {
            confirmPassword: ''
        }
    },
    methods: {
        submitForm () {
            if (this.confirmPassword === 'Aa666666') {
                eventBus.$emit('courierBookingConfirm', {})
                this.confirmPassword = ''
                this.detail.dialog = false
            } else {
                if (this.confirmPassword === '') {
                    this.$message({
                        message: 'กรุณากรอกรหัสผ่าน',
                        type: 'error',
                        showClose: true
                    })
                } else {
                    this.$message({
                        message: 'รหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่',
                        type: 'error',
                        showClose: true
                    })
                }
                this.confirmPassword = ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .booking-select-display{
        text-align: center;
        font-size: 22px;
    }
    .book-pad-btm{
        text-align: center;
        .head-font{
            font-size: 20px;
        }
    }
    .booking-pad-20{
            padding-bottom: 20px;
        }
    .custom-infor-pad{
        padding: 20px 0;
    }
</style>
